"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZoom = exports.setZoom = exports.constrainToBounds = exports.setCameraXY = exports.update = exports.getCenterXY = exports.getCenter = exports.centerOn = exports.getGameBounds = exports.getGamePositionToUiPosition = exports.getAdjustedMousePosition = exports.getUiMousePosition = exports.get = void 0;
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCameraStarmap_mover_sidecar_1 = require("./voyageCameraStarmap_mover-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        setCameraXY(0, 0);
    }
    return _obj;
}
exports.get = get;
function create() {
    var bounds = 128 * 20;
    var obj = {
        zoom: 1,
        cameraX: 0,
        cameraY: 0,
        bounds: {
            x: -bounds,
            y: -bounds,
            w: 100 * 32 + bounds * 2,
            h: 100 * 32 + bounds * 2,
        },
    };
    return obj;
}
function getUiMousePosition() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    return { mx: mx, my: my };
}
exports.getUiMousePosition = getUiMousePosition;
function getAdjustedMousePosition() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    var obj = get();
    var zoom = getZoom();
    var gx = (mx + obj.cameraX) / zoom;
    var gy = (my + obj.cameraY) / zoom;
    return { x: gx, y: gy };
}
exports.getAdjustedMousePosition = getAdjustedMousePosition;
function getGamePositionToUiPosition(gx, gy) {
    var obj = get();
    var zoom = getZoom();
    var mx = gx * zoom - obj.cameraX;
    var my = gy * zoom - obj.cameraY;
    return { x: mx, y: my };
}
exports.getGamePositionToUiPosition = getGamePositionToUiPosition;
function getGameBounds() {
    var scale = common_sidecar_1.common.getPhaserScene().sys.game.scale;
    return { width: scale.width, height: scale.height };
}
exports.getGameBounds = getGameBounds;
function centerOn(x, y) {
    var obj = get();
    var gb = getGameBounds();
    setCameraXY(x * obj.zoom - gb.width / 2, y * obj.zoom - gb.height / 2);
}
exports.centerOn = centerOn;
function getCenter() {
    var obj = get();
    var gb = getGameBounds();
    var x = obj.cameraX + gb.width / 2 / obj.zoom;
    var y = obj.cameraY + gb.height / 2 / obj.zoom;
    return { x: x, y: y };
}
exports.getCenter = getCenter;
var getCenterXY = function () {
    var obj = get();
    var gb = getGameBounds();
    return {
        x: (obj.cameraX + gb.width / 2) / obj.zoom,
        y: (obj.cameraY + gb.height / 2) / obj.zoom, // / data.zoom,
    };
};
exports.getCenterXY = getCenterXY;
function update() {
    var obj = get();
    // voyageCamera_shaker.update()
    voyageCameraStarmap_mover_sidecar_1.voyageCameraStarmap_mover.update(obj);
    // voyageCamera_zoomer.update()
    _updateLayers();
    // let ap = common.getPhaserScene().game.input.activePointer
}
exports.update = update;
function _updateLayers() {
    var obj = get();
    var layers = voyageLayers_sidecar_1.voyageLayers.getLayersOnStarmap();
    // let gs = voyageCamera_shaker.get()
    var cx = obj.cameraX; //+ gs.shakeX
    var cy = obj.cameraY; //+ gs.shakeY
    // console.log('klayers?', layers.length)
    imports_1.l.forEach(layers, function (c) {
        c.x = -cx;
        c.y = -cy;
    });
}
function setCameraXY(x, y) {
    var obj = get();
    var bounded = constrainToBounds(x, y, obj.bounds);
    obj.cameraX = bounded.x;
    obj.cameraY = bounded.y;
    _updateLayers();
}
exports.setCameraXY = setCameraXY;
function constrainToBounds(x, y, bounds) {
    var ix = x;
    var iy = y;
    var gb = getGameBounds();
    var zoom = get().zoom;
    var bx = bounds.x * zoom;
    var by = bounds.y * zoom;
    if (ix < bx) {
        ix = bx;
    }
    if (iy < by) {
        iy = by;
    }
    var bw = bounds.w * zoom;
    var br = bx + bw - gb.width;
    if (gb.width > bw) {
        br += (gb.width - bw) / 2;
    }
    if (ix > br) {
        ix = br;
    }
    var bh = bounds.h * zoom;
    var bb = by + bh - gb.height;
    if (gb.height > bh) {
        bb += (gb.height - bh) / 2;
    }
    if (iy > bb) {
        iy = bb;
    }
    x = ix;
    y = iy;
    return { x: x, y: y };
}
exports.constrainToBounds = constrainToBounds;
function setZoom(newZoom) {
    var obj = get();
    if (newZoom === obj.zoom) {
        return;
    }
    var center = exports.getCenterXY();
    obj.zoom = newZoom;
    imports_1.l.forEach(voyageLayers_sidecar_1.voyageLayers.getLayersOnMainCamera(), function (c) {
        c.scale = newZoom;
    });
    centerOn(center.x, center.y);
    center = exports.getCenterXY();
}
exports.setZoom = setZoom;
function getZoom() {
    return get().zoom;
}
exports.getZoom = getZoom;
